(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mikora-gift-quiz"] && !Shopify.designMode) return;
  try {
    
function mgqInit(section) {
  if (!section || section.dataset.mgqInited === 'true') return;
  section.dataset.mgqInited = 'true';

  var widget = section.querySelector('[data-quiz]');
  if (!widget) return;

  var panels = Array.prototype.slice.call(widget.querySelectorAll('[data-quiz-panel]'));
  var dots = Array.prototype.slice.call(widget.querySelectorAll('[data-quiz-dot]'));
  var audienceBtns = Array.prototype.slice.call(widget.querySelectorAll('[data-quiz-audience]'));
  var occasionBtns = Array.prototype.slice.call(widget.querySelectorAll('[data-quiz-occasion]'));
  var budgetBtns = Array.prototype.slice.call(widget.querySelectorAll('[data-quiz-budget-min]'));
  var backBtns = Array.prototype.slice.call(widget.querySelectorAll('[data-quiz-back]'));
  var results = Array.prototype.slice.call(widget.querySelectorAll('.mikora-quiz__result'));
  var restartBtn = widget.querySelector('[data-quiz-restart]');
  var budgetNote = widget.querySelector('[data-quiz-budget-note]');

  var state = { audience: null, occasion: null, budgetMin: null, budgetMax: null };

  function goToPanel(num) {
    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-quiz-panel') === String(num));
    });
    dots.forEach(function (dot) {
      var dotNum = parseInt(dot.getAttribute('data-quiz-dot'), 10);
      dot.classList.toggle('is-active', dotNum <= num);
    });
  }

  function splitKeys(value) {
    return (value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function findMatch() {
    var exact = null, audienceOnly = null, occasionOnly = null, first = null;
    for (var i = 0; i < results.length; i++) {
      var el = results[i];
      var audienceMatch = splitKeys(el.getAttribute('data-quiz-audience-match'));
      var occasionMatch = splitKeys(el.getAttribute('data-quiz-occasion-match'));
      var okAudience = audienceMatch.length === 0 || audienceMatch.indexOf(state.audience) !== -1;
      var okOccasion = occasionMatch.length === 0 || occasionMatch.indexOf(state.occasion) !== -1;
      if (!first) first = el;
      if (okAudience && okOccasion && !exact) exact = el;
      if (okAudience && occasionMatch.length === 0 && !audienceOnly) audienceOnly = el;
      if (okOccasion && audienceMatch.length === 0 && !occasionOnly) occasionOnly = el;
    }
    return exact || audienceOnly || occasionOnly || first;
  }

  function showResult() {
    var matched = findMatch();
    results.forEach(function (el) {
      el.hidden = el !== matched;
    });

    var usedFallback = false;
    if (matched) {
      var cards = Array.prototype.slice.call(matched.querySelectorAll('.mikora-quiz__product-card'));
      if (cards.length > 0) {
        var anyVisible = false;
        cards.forEach(function (card) {
          var price = parseFloat(card.getAttribute('data-quiz-price'));
          var okMin = state.budgetMin === null || isNaN(price) || price >= state.budgetMin;
          var okMax = !state.budgetMax || isNaN(price) || price <= state.budgetMax;
          var withinBudget = okMin && okMax;
          card.hidden = !withinBudget;
          if (withinBudget) anyVisible = true;
        });
        if (!anyVisible) {
          cards.forEach(function (card) { card.hidden = false; });
          usedFallback = true;
        }
      }
    }
    if (budgetNote) budgetNote.hidden = !usedFallback;

    goToPanel(4);
  }

  audienceBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.audience = btn.getAttribute('data-quiz-audience');
      audienceBtns.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      goToPanel(2);
    });
  });

  occasionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.occasion = btn.getAttribute('data-quiz-occasion');
      occasionBtns.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      goToPanel(3);
    });
  });

  budgetBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var min = parseFloat(btn.getAttribute('data-quiz-budget-min'));
      var max = parseFloat(btn.getAttribute('data-quiz-budget-max'));
      state.budgetMin = isNaN(min) ? null : min;
      state.budgetMax = (!max || isNaN(max)) ? null : max;
      budgetBtns.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      showResult();
    });
  });

  backBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-quiz-back');
      goToPanel(target);
    });
  });

  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      state = { audience: null, occasion: null, budgetMin: null, budgetMax: null };
      audienceBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      occasionBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      budgetBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      results.forEach(function (el) { el.hidden = true; });
      goToPanel(1);
    });
  }
}

function mgqInitAll(context) {
  var scope = context || document;
  var sections = scope.querySelectorAll ? scope.querySelectorAll('.mikora-quiz-section') : [];
  Array.prototype.slice.call(sections).forEach(mgqInit);
  if (scope.classList && scope.classList.contains('mikora-quiz-section')) {
    mgqInit(scope);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  mgqInitAll(document);
});

document.addEventListener('shopify:section:load', function (event) {
  mgqInitAll(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mikora-hero-banner"] && !Shopify.designMode) return;
  try {
    
function mhbInitCarousel(root) {
  if (!root || root.dataset.mhbInited === 'true') return;
  root.dataset.mhbInited = 'true';

  var slides = Array.prototype.slice.call(root.querySelectorAll('.mikora-hero-banner__slide'));
  if (slides.length < 2) return;

  var wrap = root.closest('.mikora-hero-banner__media-wrap') || root;
  var dots = Array.prototype.slice.call(wrap.querySelectorAll('.mikora-hero-banner__dot'));
  var prevBtn = wrap.querySelector('.mikora-hero-banner__arrow--prev');
  var nextBtn = wrap.querySelector('.mikora-hero-banner__arrow--next');
  var index = 0;
  var timer = null;

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach(function (slide, idx) {
      slide.classList.toggle('is-active', idx === index);
    });
    dots.forEach(function (dot, idx) {
      dot.classList.toggle('is-active', idx === index);
    });
  }

  function next() { goTo(index + 1); }
  function prev() { goTo(index - 1); }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function startAutoplay() {
    if (root.dataset.autoplay !== 'true') return;
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    stopAutoplay();
    timer = setInterval(next, interval);
  }

  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      next();
      resetAutoplay();
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      prev();
      resetAutoplay();
    });
  }
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      goTo(i);
      resetAutoplay();
    });
  });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  // Touch swipe support
  var touchStartX = 0;
  var touchDeltaX = 0;
  root.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchDeltaX = 0;
    stopAutoplay();
  }, { passive: true });
  root.addEventListener('touchmove', function (e) {
    touchDeltaX = e.touches[0].clientX - touchStartX;
  }, { passive: true });
  root.addEventListener('touchend', function () {
    if (Math.abs(touchDeltaX) > 40) {
      if (touchDeltaX < 0) { next(); } else { prev(); }
    }
    resetAutoplay();
  });

  startAutoplay();

  root.mhbCleanup = stopAutoplay;
}

function mhbInitAll(context) {
  var scope = context || document;
  var roots = scope.querySelectorAll ? scope.querySelectorAll('[data-mhb-carousel]') : [];
  Array.prototype.slice.call(roots).forEach(mhbInitCarousel);
  if (scope.matches && scope.matches('[data-mhb-carousel]')) {
    mhbInitCarousel(scope);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  mhbInitAll(document);
});

document.addEventListener('shopify:section:load', function (event) {
  mhbInitAll(event.target);
});

document.addEventListener('shopify:section:unload', function (event) {
  var root = event.target.querySelector('[data-mhb-carousel]');
  if (root && root.mhbCleanup) {
    root.mhbCleanup();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mikora-how-it-works"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-photo-guide-open]');
  if (opener) {
    var targetId = opener.getAttribute('aria-controls');
    var modal = targetId && document.getElementById(targetId);
    if (modal) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    return;
  }
  var closer = e.target.closest('[data-photo-guide-close]');
  if (closer) {
    var modal = closer.closest('.mikora-how-it-works__photo-guide-modal');
    if (modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
  }
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.mikora-how-it-works__photo-guide-modal:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mikora-ugc-wall"] && !Shopify.designMode) return;
  try {
    
function mugcInit(section) {
  if (!section || section.dataset.mugcInited === 'true') return;
  section.dataset.mugcInited = 'true';

  var track = section.querySelector('[data-mugc-track]');
  if (!track) return;
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-mugc-card]'));

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('.mikora-ugc__video');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { root: track, threshold: [0, 0.6, 1] })
    : null;

  cards.forEach(function (card) {
    var video = card.querySelector('.mikora-ugc__video');
    var muteBtn = card.querySelector('[data-mugc-mute]');

    if (video) {
      if (observer) observer.observe(card);

      video.addEventListener('play', function () {
        card.classList.remove('is-paused');
      });
      video.addEventListener('pause', function () {
        card.classList.add('is-paused');
      });
      card.classList.add('is-paused');

      card.addEventListener('click', function (event) {
        if (muteBtn && (event.target === muteBtn || muteBtn.contains(event.target))) return;
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    if (muteBtn && video) {
      muteBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        video.muted = !video.muted;
        card.classList.toggle('is-muted', video.muted);
      });
      card.classList.add('is-muted');
    }
  });

  var prevBtn = section.querySelector('.mikora-ugc__arrow--prev');
  var nextBtn = section.querySelector('.mikora-ugc__arrow--next');
  function scrollByCard(direction) {
    var card = cards[0];
    var amount = card ? card.getBoundingClientRect().width + 16 : 240;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
}

function mugcInitAll(context) {
  var scope = context || document;
  var sections = scope.querySelectorAll ? scope.querySelectorAll('.mikora-ugc-section') : [];
  Array.prototype.slice.call(sections).forEach(mugcInit);
  if (scope.classList && scope.classList.contains('mikora-ugc-section')) {
    mugcInit(scope);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  mugcInitAll(document);
});

document.addEventListener('shopify:section:load', function (event) {
  mugcInitAll(event.target);
});

  } catch(e) { console.error(e); }
})();
})();
